import * as React from "react";
import classnames from "classnames";
/* empty css                  */
const CheckboxView = ({
  id,
  className,
  name,
  label,
  checked,
  disabled,
  error,
  required,
  ...rest
}) => {
  const inputRef = React.useRef(null);
  const onClick = (e) => {
    rest.onChange && rest.onChange({
      value: rest?.value,
      checked: e.currentTarget.checked
    });
  };
  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = checked === "mixed";
    }
  }, [checked, inputRef]);
  return /* @__PURE__ */ React.createElement(
    "label",
    {
      className: classnames(
        "checkbox-view",
        { "checkbox-view__error": error && !checked },
        className
      )
    },
    /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "checkbox-view__input",
        type: "checkbox",
        id,
        name,
        "aria-checked": checked,
        "aria-label": rest["aria-label"],
        "aria-labelledby": rest["aria-label"] || !id ? void 0 : `label_${id}`,
        "aria-invalid": error && !checked,
        "aria-describedby": error && !checked ? rest?.errorId || `error_${id}` : void 0,
        checked: typeof checked === "boolean" ? checked : false,
        disabled,
        onChange: disabled ? void 0 : onClick,
        "data-t": rest["data-t"],
        tabIndex: 0,
        ref: inputRef,
        value: "0",
        required
      }
    ),
    /* @__PURE__ */ React.createElement("span", { className: "checkbox-view__mask", "aria-hidden": true }),
    checked === "mixed" ? /* @__PURE__ */ React.createElement("span", { className: "checkbox-view__indeterminate", "aria-hidden": true }) : /* @__PURE__ */ React.createElement(
      "svg",
      {
        className: "checkbox-view__checkmark",
        width: "14",
        height: "13",
        viewBox: "0 0 14 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true
      },
      /* @__PURE__ */ React.createElement("path", { d: "M1 7.5L4.5 12L13 1", fill: "none" })
    ),
    /* @__PURE__ */ React.createElement("span", { id: id && `label_${id}`, className: "checkbox-view__label" }, label)
  );
};
export {
  CheckboxView as default
};
//# sourceMappingURL=CheckboxView.js.map
